import type { ImageTranscodeUrl } from '../../generated';
import type { TypePolicies } from '../../utils/types/TypePolicies';

const thumbnailImageUrlMerge = (
  existing: Readonly<ImageTranscodeUrl> | null | undefined,
  incoming: Readonly<ImageTranscodeUrl> | null | undefined
) => {
  const incomingValue = incoming ?? null;
  const existingValue = existing ?? null;
  return !incomingValue ? existingValue : incomingValue;
};

export const typePolicies: TypePolicies = {
  TransferBatch: {
    // potentiallly disable caching TransferBatch if it affect performance
    // keyFields: false,
  },
  AudioAsset: {
    fields: {
      thumbnailImageUrl: {
        merge: thumbnailImageUrlMerge,
      },
    },
  },
  DocumentAsset: {
    fields: {
      thumbnailImageUrl: {
        merge: thumbnailImageUrlMerge,
      },
    },
  },
  ImageAsset: {
    fields: {
      thumbnailImageUrl: {
        merge: thumbnailImageUrlMerge,
      },
    },
  },
  VideoAsset: {
    fields: {
      thumbnailImageUrl: {
        merge: thumbnailImageUrlMerge,
      },
    },
  },
  AssetItem: {
    // potentiallly disable caching AssetItem if it affect performance
    // keyFields: false,
  },

  Subscription: {
    fields: {
      transferBatch: {
        merge: true,
      },
    },
  },
};
